import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import {
  HomeOutlined,
  AccessTimeOutlined,
  CalendarTodayOutlined,
} from "@material-ui/icons";

import "./styles.scss";
import { withRouter } from "react-router-dom";
import { detectLanguage } from "../../utils/utils";
import Constants from "../../utils/constants";

const { HomePageTitle, EtaPageTitle, SchedulePageTitle } =
  Constants["LANGUAGES"];

const NavBar = (props) => {
  const { courtId, userId, lang, site, court, goToPage, themeColour } = props;
  // const { court } = props.match.params;
  // const [courtId, setCourtId] = useState(null)
  const [selected, setSelected] = useState(0);

  // useEffect(() => {
  //     setCourtId(props.history.location.pathname.split("/")[2])
  //     const langObj = detectLanguage(props)
  //     setLang(langObj.language)
  // }, [props])

  useEffect(() => {
    if (props.history.location.pathname.includes("/schedule")) {
      setSelected(1);
    } else {
      setSelected(0);
    }
  }, [props.history.location.pathname]);

  const isSelected = (index) => {
    return selected === index ? "selected" : "";
  };

  function colour(isSelected) {
    const resultColour = themeColour || "#3399ff";
    if (!isSelected) {
      return {color: "#9E9E9E"};
    }
    return {color: resultColour};
  }

  return (
    <Grid container className="navbar">
      <Grid item xs={6} style={{ color: themeColour }}>
        <div
          className={`icon-container ${court}`}
          style={colour(isSelected(0))}
          onClick={() => goToPage("")}
        >
          <div className="icon-wrapper">
            <HomeOutlined style={{ fontSize: "32px" }} />
          </div>
          <span className="title">{HomePageTitle[lang]}</span>
        </div>
      </Grid>

      <Grid item xs={6}>
        <div
          className={`icon-container ${court}`}
          style={colour(isSelected(1))}
          onClick={() => goToPage("/schedule")}
        >
          <div className="icon-wrapper">
            <CalendarTodayOutlined style={{ fontSize: "23px" }} />
          </div>
          <span className="title">{SchedulePageTitle[lang]}</span>
        </div>
      </Grid>
    </Grid>
  );
};

export default withRouter(NavBar);
